<template>
  <div class="form-group">
    <label :class="{ checked: checked }"
           class="checkbox"
    >
      <input v-taptic="'selection'"
             type="checkbox"
             class="cursor-pointer"
             :name="name"
             :checked="checked"
             :data-test-id="dataTestId"
             @click="checkCategory()"
      >
      <slot><!--Checkbox label text--></slot>
    </label>
  </div>
</template>
<script setup lang="ts">

import { computed } from "vue"
import { useMarketplaceStore } from "@/stores/ssr/useMarketplaceStore"

const marketplaceStore = useMarketplaceStore()

const props = withDefaults(defineProps<{
  name: string,
  value: number,
  dataTestId?: string | null
}>(), {
  dataTestId: null,
})

const checked = computed(() => marketplaceStore.filteredCategories.includes(props.value))

const checkCategory = () => {
  marketplaceStore.toggleFilteredCategory(props.value)
}
</script>
<style lang="scss" scoped>
@import "@/assets/css/mixins/styling.scss";
@import "@/assets/css/mixins/interactions.scss";

.checkbox {
  display:    flex;
  align-items: center;
  transition: color 110ms ease-out;

  [type="checkbox"] {
    width:           1.25rem;
    height:          1.25rem;
    border:          1px solid var(--color-neutral-tertiary);
    border-radius:   0.25rem;
    margin-right:    0.75rem;
    display:         flex;
    align-items:     center;
    justify-content: center;
    -webkit-appearance: none;
    transition:      border 150ms ease-out;

    &:before {
      content: url("/assets/img/check.svg");
      display: block;
      position: relative;
      width:   1rem;
      top:     0.125rem;
    }

    &:checked {
      border: 1px solid var(--color-brand-primary);
      @include gradient-bg;

      &:before {
        opacity: 1;
        transition: opacity 110ms ease-out;
      }
    }
  }

  @include hover {
    &:hover {
      cursor: pointer;

      [type="checkbox"] {
        border: 1px solid var(--color-brand-primary);
        transition: border 150ms ease-out;
      }
    }
  }
}

.form-group {
  display: flex;
  align-items: center;
}
</style>
